import Param from './param';
import Util from './module/libs/util';
import effectManager from './module/effect';
import globalNavi from './module/global/globalNavi';
import ModalManager from './module/modal/modalManager';
import linkLineHover from './module/global/linkLineHover';
import topManager from './page/top';
import reuseManager from './page/reuse';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';

const param = new Param();
const util = new Util();
const gNavi = new globalNavi();
let modal;
let linkLine;
let effect;
let scroll;
let mouse;
let toppage;
let reusepage;

//const stats = new Stats();
//stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
//document.body.appendChild( stats.dom );

let pageID = $("body").attr("id");
let executionType = "landing"; /* 実行タイミングの制御用 */
let fpsRate = 0;
let scrFlg = false;
let _pjaxFlg = false;
let _pjaxTarget;
let _pjaxType;

let _cover = $("#p-pjax-cover .l-cover");

/* ---------------------------------------------------

  -- render

 --------------------------------------------------- */

let render = function () {

    if(!requestAnimationFrame){
        setTimeout(()=>{
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }

    if(_pjaxFlg) return;

    //stats.begin();

    fpsRate = util.updateTimeRatio();

    if(!modal.status.flg) scroll.move(fpsRate,param.displayType);
    if(modal.status.mouseFlg) mouse.move();

    if(pageID==="top") {
        if(!scroll.kvFlg) {
            toppage.render("",scroll.inc);
        }
        scrFlg = toppage.splashFlg;
    }
    if(modal.status.mouseFlg) modal.render(mouse.obj,scroll.inc);

    //stats.end();

}

/* ---------------------------------------------------

  --

 --------------------------------------------------- */


let common = function () {

    let $header = $("#l-header");

    param.displayType = ( Useragnt.pc||Useragnt.tablet )?"pc":"sp";

    if(executionType==="landing"){

        effect = new effectManager();
        scroll = new smoothScrollManager(pageID);
        mouse = new MouseManager();
        modal = new ModalManager(scroll);
        linkLine = new linkLineHover();

        effect.bg(_cover,"set");

        if(param.displayType === 'sp'){
            TweenMax.set($header,{y:-60});
        }else{
            TweenMax.set($header,{x:-100});
            TweenMax.set($("#l-scrolldown"),{x:300});
        }
        TweenMax.set($("#l-header__inner"),{"backgroundColor":"#fff"});
        TweenMax.set($("#l-header-trigger").children().children(),{"backgroundColor":param.conf.keycolor});
        TweenMax.set($("#l-header-logo-white"),{ "opacity":0 });
        TweenMax.set($("#l-header-logo-color"),{ "opacity":1 });

        modal.init(pageID);
        linkLine.init();
        gNavi.init();

        setTimeout(()=>{
            resize();
            scroll.init(pageID);
        },1e2);
        setTimeout(()=>{
            resize();
        },1e3);
        setTimeout(()=>{
            render();
        },3e2);

    }else{
        TweenMax.set($header,{opacity:1});
        modal.init(pageID);
        linkLine.init();
        gNavi.init();
        setTimeout(()=>{
            resize();
            scroll.init(pageID);
        },1e2);
    }

    setTimeout(()=>{

        let _delay = 0;
        if(pageID === 'top'){
            _delay = 4;
        }
        TweenMax.set($header,{opacity:1});
        TweenMax.to($("#l-header,#l-scrolldown"),0.4,{x:0,y:0,delay:_delay,ease:Power2.easeOut});
        TweenMax.set($("#l-root__inner"),{opacity:1,"backgroundColor":"#fff"});
        TweenMax.set($(".l-modal__inner,#p-kv,#l-body-bg"),{opacity:1});
    },1e3);

    pageManager(pageID);

}

let pageManager = function(){

    switch(pageID){
        case "top":
            toppage = new topManager();
            setTimeout(()=>toppage.init(param.displayType,executionType),5e2);
            break;
        case "reuse":
            reusepage = new reuseManager();
            if(executionType==="landing" || _pjaxType === 'gnavi') reusepage.splash();
            reusepage.init(param.displayType,executionType);
            break;
    }


    if(pageID !== 'top'){
        scrFlg = true;
    }

}

let resize = function () {

    if(pageID==="top"){

        toppage.resize();

    }

    if(pageID==="reuse"){

        reusepage.resize();

    }

    scroll.resize(pageID);
    modal.resize();

}


/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

$(window).on("load", function (e) {
// Pace.on("done", function () {
    executionType = "landing";
    common();
    $('html,body').animate({ scrollTop: 0 }, '1');
    let _delay = Useragnt.ie ? 1e3 : 5e2;

});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

$("a[target!='_blank']").on("click",function () {
    $(this).addClass("is-none"); /* 非同期遷移用にダブルクリックの対策 */
})

/* lowlayer scroll */
$(window).on("scroll", function (e) {

    if(modal.status.flg&&modal.status.select.parent!=="company" && modal.status.flg&&modal.status.select.parent!=="news" || !scrFlg) return false;

    let _y = !Useragnt.tablet || pageID !== 'top' ? window.pageYOffset || document.documentElement.scrollTop : window.pageXOffset || document.documentElement.scrollLeft;
   scroll.update(_y,"");

});

// $(window).on('mousewheel', function(e) {

//     console.log(scroll.status.stop);

//     if(modal.status.flg&&modal.status.select.parent!=="company" || !scrFlg || scroll.status.stop){

//         e.preventDefault();
//         e.stopPropagation();
//         return;
//     }
// }, {passive: true});

document.addEventListener("mousewheel",function (e) {

    if(modal.status.flg&&modal.status.select.parent!=="company" && modal.status.flg&&modal.status.select.parent!=="news" || !scrFlg){

        e.preventDefault();
        e.stopPropagation();
        return;
    }

}, {passive: false});

let _touchStartY = 0;

document.addEventListener("touchstart",function (e) {
    // if(modal.status.flg&&modal.status.select.parent!=="company"||!scrFlg){
    //     e.preventDefault();
    //     e.stopPropagation();
    //     return;
    // }

    // _touchStartY = e.pageY;
});
document.addEventListener("touchmove",function (e) {
    if(Useragnt.tablet||Useragnt.mobile){
        if(modal.status.flg&&modal.status.select.parent!=="company"||!scrFlg){
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    }
});

window.addEventListener("mousemove",function (e) {

    let _x = e.clientX;
    let _y = e.clientY;


    if(mouse) mouse.update(_x,_y);

});


$(window).on("resize",function (e) {
    executionType = "resize";
    resize();

});
$(window).on("onorientationchange",function (e) {
    executionType = "onorientationchange";
    resize();

});

$(window).on("load orientationchange resize", function() {

    if(Math.abs(window.orientation) === 90) {
        $('html').addClass('yoko');
    } else {
        $('html').removeClass('yoko');
    }
});


/* ---------------------------------------------------

  -- PJAX

 --------------------------------------------------- */

Barba.Pjax.start();
Barba.Prefetch.init();

var PageTransition = Barba.BaseTransition.extend({
    start: function() {

        /* 画面遷移する際に発火 */

        if(_pjaxFlg) return false;
        _pjaxFlg = true;

        if(gNavi.status.now === 'open'){
            _pjaxType = 'gnavi';
        }else{
            _pjaxType = 'normal';
        }


        Promise
            .all([this.newContainerLoading, this.out()])
            .then(this.show.bind(this));
    },

    out: function() {

        /* 画面遷移時に消える処理 */
        if(_pjaxTarget === 'reuse' && $('body#top')[0]){ // csr
            $('#l-progressbar').remove();
            if(_pjaxType === 'gnavi'){
                effect.show($(".js__navi-show"),"out");
                effect.bgImg($('#l-header-navi-bg-image>*'),"out");
            }
        }else if(_pjaxTarget === 'top'){ // top first
            if(_pjaxType === 'gnavi'){
                effect.show($(".js__navi-show"),"out");
            }else{
                effect.bg(_cover,"show");
            }
        }else{ // top other
            effect.show($(".js__navi-show"),"out");
            effect.bgImg($('#l-header-navi-bg-image>*'),"out");
        }
        effect.pjax(_pjaxTarget,"out",_pjaxType);
        $('body').css({'background-color':'transparent'});

        let _this = this;

        TweenMax.set($(_this.oldContainer),{delay:3,visibility : 'visible',opacity : 0});

    },

    show: function() {

        let headerReset = function() {
            TweenMax.set($("#l-header__inner"), {"backgroundColor": "#fff"});
            TweenMax.set($("#l-header-trigger").children().children(), {"backgroundColor": param.conf.keycolor});
            TweenMax.set($("#l-header-logo-white"), {"opacity": 0});
            TweenMax.set($("#l-header-logo-color"), {"opacity": 1});
        }
        let headerResetAnime = function(){
            TweenMax.to($("#l-header__inner"),0.4,{
                "backgroundColor":"#fff"
            });
            TweenMax.to($("#l-header-trigger").children().children(),0.4,{
                "backgroundColor":param.conf.keycolor
            });
            TweenMax.to($("#l-header-logo-white"),0.4,{
                "opacity":0
            });
            TweenMax.to($("#l-header-logo-color"),0.4,{
                "opacity":1
            });
        }

        /* 画面遷移時に表示される処理 */

        var _this = this;
        var $el = $(this.newContainer);
        let _delay = '1e2';

        if(param.displayType !== 'sp' || _pjaxType === 'gnavi'){
            _delay = 300;
            $('html,body').animate({ scrollTop: 0 }, '1',function(){
                effect.pjax(_pjaxTarget,"set");
            });
        }

        setTimeout(()=>{

            if(_pjaxType === 'gnavi'){
                effect.bg(_cover,"showset");
            }

            $(_this.oldContainer).hide();
            $("body").attr("id",pageID);
            TweenMax.set($("#l-header"), {opacity: 1});

            TweenMax.set($el, {
                opacity: 1,
                onComplete: function () {

                    $("#p-kv-splash-cover").css({'display': 'none'});
                    TweenMax.set($("#l-root"), { opacity: 1 });
                    effect.bg($("#l-header-navi-bg >.l-bg"),"set");
                    _this.done();
                    common();
                    _pjaxFlg = false;
                    scroll.kvFlg = false;
                    scrFlg = true;

                    if(_pjaxTarget === 'top' && _pjaxType === 'normal' || _pjaxTarget === 'reuse' && _pjaxType === 'normal'){
                        headerReset();
                    }

                    setTimeout(()=>{
                        resize();
                        TweenMax.set($('#p-pjax-photo'), {
                            display: 'none'
                        });
                    },_delay);

                    if(_pjaxTarget === 'reuse' && $('body#reuse')[0]){ // csr

                        if(_pjaxType === 'normal') {
                            TweenMax.set($('#p-kv').find('.l-img'), {
                                opacity: 1
                            });
                        }else{
                            effect.bg(_cover, "out");
                            headerResetAnime();
                        }

                    }else if(_pjaxTarget === 'top'){ // top first

                        setTimeout(()=> {
                            resize();
                            $('body').css({'background-color': '#03092d'});
                            effect.bg(_cover, "out");
                            headerResetAnime();
                        },1e3);

                    }else if(_pjaxTarget === undefined || _pjaxTarget === '') { // other

                        setTimeout(()=> {
                            $("#p-kv-splash-cover").css({'display': 'none'});
                            headerResetAnime();
                        },1e3);

                    }else { // top other

                        _cover.removeAttr('style');
                        $('body').css({'background-color': '#03092d'});
                        setTimeout(()=>{
                            if(param.displayType === 'sp'){
                                $('html,body').animate({scrollTop: $("#p-"+_pjaxTarget).offset().top }, '1', function () {
                                    effect.bg(_cover, "out");
                                    headerResetAnime();
                                });
                            }else{
                                if(Useragnt.tablet){
                                    setTimeout(()=>{
                                        resize();
                                        $('html,body').animate({scrollLeft: $("#p-"+_pjaxTarget).offset().left}, '1', function () {
                                            effect.bg(_cover, "out");
                                            headerResetAnime();
                                        });
                                    },600);
                                }else{
                                    resize();
                                    $('html,body').animate({scrollTop: $("#p-"+_pjaxTarget).offset().left}, '1', function () {
                                        effect.bg(_cover, "out");
                                        headerResetAnime();
                                    });
                                }
                            }
                        },300);

                    }
                }
            });

        },1e3);

    }
});



Barba.Dispatcher.on('linkClicked', function() {
    //console.log("開始");

});
Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {


    /* ページ情報取得 */
    pageID = currentStatus.namespace;

    /* head内書き換え */
    var head = document.head;
    var newPageRawHead = newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    var newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    var removeHeadTags = [
        "meta[name='keywords']"
        ,"meta[name='description']"
        ,"meta[property^='og']"
        ,"meta[name^='twitter']"
        ,"meta[itemprop]"
        ,"link[itemprop]"
        ,"link[rel='prev']"
        ,"link[rel='next']"
        ,"link[rel='canonical']"
    ].join(',');
    var headTags = head.querySelectorAll(removeHeadTags)
    for(var i = 0; i < headTags.length; i++ ){
        head.removeChild(headTags[i]);
    }
    var newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for(var i = 0; i < newHeadTags.length; i++ ){
        head.appendChild(newHeadTags[i]);
    }

    executionType = "pjax";

    //アナリティクスに送信
    // ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search);

    /* html書き換え */

});

Barba.Pjax.getTransition = function() {
    // console.log("getTransition");
    return PageTransition;
};
Barba.Dispatcher.on("load", function() {
    // console.log("test");
});

Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
Barba.Pjax.preventCheck = function(evt, element) { //ハッシュが含まれていてもbarbaが機能するように

    _pjaxTarget = $(element).data('target');

    if ($(element).attr('href') && $(element).attr('href').indexOf('#') > -1)
        return true;
    else
        return Barba.Pjax.originalPreventCheck(evt, element)
};

